import { render, staticRenderFns } from "./CoinCustomizationForm.vue?vue&type=template&id=9b8473ee&scoped=true&"
import script from "./CoinCustomizationForm.vue?vue&type=script&lang=ts&"
export * from "./CoinCustomizationForm.vue?vue&type=script&lang=ts&"
import style0 from "./CoinCustomizationForm.vue?vue&type=style&index=0&id=9b8473ee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8473ee",
  null
  
)

export default component.exports